import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Search } from "lucide-react";
import api from "@/lib/api";
import useSeo from "@/hooks/useSeo";
import NewsCard from "@/components/NewsCard";

export default function SearchResults() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [items, setItems] = useState(null);
  useSeo({ title: `Búsqueda: ${q}`, description: `Resultados de búsqueda para "${q}" en NEXODUM.` });

  useEffect(() => {
    setItems(null);
    api.get(`/articles?q=${encodeURIComponent(q)}&limit=40`).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [q]);

  return (
    <div data-testid="search-page" className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 py-12 min-h-[60vh]">
      <div className="flex items-center gap-3 mb-8">
        <Search className="text-nx-orange" size={26} />
        <h1 className="font-serif font-black text-2xl md:text-4xl text-nx-dark">Resultados para “{q}”</h1>
      </div>
      {!items ? (
        <div className="animate-pulse grid gap-6">{[1, 2, 3].map((i) => <div key={i} className="h-32 bg-gray-100 rounded" />)}</div>
      ) : items.length === 0 ? (
        <div className="text-center py-20">
          <p className="text-gray-500">No encontramos resultados para tu búsqueda.</p>
          <Link to="/" className="mt-4 inline-block text-nx-orange font-bold">Volver al inicio</Link>
        </div>
      ) : (
        <>
          <p className="text-sm text-gray-500 mb-6">{items.length} resultado(s)</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10">
            {items.map((a) => <NewsCard key={a.id} article={a} variant="grid" />)}
          </div>
        </>
      )}
    </div>
  );
}
